<script>

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import LoadingButton from '@/components/General/LoadingButton'
import Alert from '@/components/General/Alert'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getWeather, unlockWeather, deleteWeather } from '@/services/weather/serviceWeather';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'WeatherDelete',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,LoadingButton
		,Alert
	},
	props: {'weatherId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["weatherId","changeRecord"],
	data() {
		return {
			prefix:'',
			
			params:[],
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			recordID:null,
			
			//form
			data:[]
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
	
		// load data form
		onLoadPage:function(){


			this.isLoading=true
			getWeather({weatherId:this.weatherId}).then(response => {
				if(!response.statusText){
					console.log(response)
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
		/*	this.isLoading=true
			
			//console.log(this.weatherId);				
			if(this.weatherId){
				this.isNewRecord=false;
			}else{
				this.isNewRecord=true;
			}
			
			var bodyFormData = new FormData();
			bodyFormData.set('weatherId',this.weatherId);
			
			
			axios({
				method: 'post',
				url: '/admins/app/customWeather/WeatherBasic/getWeatherData.php',
				data: bodyFormData
			})
			.then(function (response) {
			
				//console.log(response.data);
				this.metaData = response.data.metaData;
				
				//hide loader
				this.isLoading=false
				
				this.metaData = response.data.metaData;
								
				this.data = response.data.data;
				
			})
				.catch(function (error) {
				console.log(error);
				
				
			});*/
		
		},
		
	
		
		onClose:function(){
			if(this.weatherId!='null'){
				unlockWeather(this.weatherId).then(response => {
					if(!response.statusText){
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},


		//odomknutie zaznamu
	/*	unLock:function(weatherId){
			
			this.cSession();
			var bodyFormData = new FormData();
			bodyFormData.set('myRecordID',weatherId);
				
			axios({
				method: 'post',
				url: '/admins/app/customWeather/WeatherBasic/controlWeatherUnlock.php',
				data: bodyFormData
			})
			.then(response => {
				if (response.data.error) {
						console.log('error', response.data.error)
				} else {
					//console.log(response.data);
					if(response.data==1){
						this.$emit('changeRecord', '')
					}else if(response.data==0){
						//xx
					}else if(response.data==2){
						//xx
					}else if(response.data==3){
						//xx
					}
					
				}
			})
			.catch(error => {
				console.log(error.response)
			}); 
			
		},*/


		onDelete:function(){
			
			if(this.data.id){

				this.isSending=true
				deleteWeather({data:this.data}).then(response => {
					if(!response.statusText){
						this.isSending=false
						if(response.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasDeleted'));
							this.$emit('changeRecord', '')
							this.data = [];
							this.modalObject.hide();
						}else if(response.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
						}else if(response.resCode==2){
							this.toast.warning(this.$t('msgCore.dataWasNotDeleted'));
						}else if(response.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}else{
						this.isSending=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
				
			}
			
		}
		
		/*deleteWeather:function(weatherId){
			
			if(weatherId){
				
				var bodyFormData = new FormData();
				bodyFormData.set('myWeather',JSON.stringify(this.data));
				
				axios({
					method: 'post',
					url: '/admins/app/customWeather/WeatherBasic/controlWeatherDelete.php',
					data: bodyFormData
				})
				.then(response => {
					if (response.data.error) {
							console.log('error', response.data.error)
					} else {
						//console.log('delete', response.data);
						if(response.data.resCode==1){
							this.toast.success(this.$t('msgCore.dataWasDeleted'));
							this.modalObject.hide();
							this.$emit('changeRecord', '')
							this.data = [];
						}else if(response.data.resCode==0){
							this.toast.warning(this.$t('msgCore.dataCantBeDeleted'));
						}else if(response.data.resCode==2){
							this.toast.error(this.$t('msgCore.dataWasNotDeleted'));
						}else if(response.data.resCode==3){
							this.toast.error(this.$t('msgCore.accessDenied'));
						}
					}
				})
				.catch(error => {
					console.log(error.response)
				}); 
				
			}
			
		}*/
	
		
	},
	
	watch: {
		weatherId() {
			this.onLoadPage();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
	
	<div class="modal fade" :id="modalId" tabindex="-1" >
		<div class="modal-dialog">	
			<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			<div class="modal-content">
				<div class="modal-header">
					<h6 class="modal-title">{{ $t('msgCore.DELETE_RECORD') }} <b><span>{{ data.name }} {{ data.surname }}</span></b></h6>
					
				</div>
		
						<div v-if="metaData.modulAccess && (auth.weatherDelete)" class="modal-body">
						
							<div class="form-row">
							
								<div class="form-group col-md-2 col-12">
																																			
									<label><b>{{ $t('msgCore.ID') }}</b></label><br>
									{{data.id}}
								</div>
								
								<div class="form-group col-md-10 col-12">
																																			
									<label><b>{{ $t('msgCore.Title') }}</b></label><br>
									{{ data.name }}
								</div>
								
							</div>	
									
								
						</div>
						
						<div v-else class="modal-body">
							<div class="row">
								<div class="col-12 mt-3">
									<Alert type="warning" :label="$t('msgCore.accessDenied')" />
								</div>
							</div>
						</div>
								
						
						<div class="modal-footer">
						
							<div class="btn-group">
								<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>

								
								<LoadingButton :isDisabled="(!auth.weatherDelete || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onDelete" :label="'msgCore.btnDelete'" color="danger"></LoadingButton>
							</div>	
							
						</div>
					
			</div>

		</div>
		
	</div>
	
</div>	
</template>


